/**
 * TourScan offline store.
 * Uses Dexie (IndexedDB) to queue QR scans when the device has no internet.
 * Queue items are synced to the server when connectivity is restored.
 */
import Dexie from 'dexie';
class TourScanOfflineDB extends Dexie {
    constructor(tenantId) {
        // separate DB per tenant
        super(`tourscan_offline_${tenantId}`);
        this.version(1).stores({
            pendingScans: '++id, sessionId, scannedAt',
        });
    }
}
// Singleton map per tenant
const dbMap = new Map();
export function getOfflineDB(tenantId) {
    if (!dbMap.has(tenantId)) {
        dbMap.set(tenantId, new TourScanOfflineDB(tenantId));
    }
    return dbMap.get(tenantId);
}
export async function enqueueScan(tenantId, sessionId, qrCode) {
    const db = getOfflineDB(tenantId);
    await db.pendingScans.add({
        tenantId,
        sessionId,
        qrCode,
        status: 'PRESENT',
        scannedAt: Date.now(),
        retries: 0,
    });
}
export async function getPendingCount(tenantId, sessionId) {
    const db = getOfflineDB(tenantId);
    return db.pendingScans.where('sessionId').equals(sessionId).count();
}
export async function getAllPending(tenantId) {
    const db = getOfflineDB(tenantId);
    return db.pendingScans.toArray();
}
export async function deletePendingScan(tenantId, id) {
    const db = getOfflineDB(tenantId);
    await db.pendingScans.delete(id);
}
export async function incrementRetries(tenantId, id) {
    const db = getOfflineDB(tenantId);
    const item = await db.pendingScans.get(id);
    if (item)
        await db.pendingScans.update(id, { retries: item.retries + 1 });
}
//# sourceMappingURL=tourscan-offline.js.map